// extracted by mini-css-extract-plugin
module.exports = {"ftop":"ftop_ftop__3-hup"};